import { IRender } from '../parseTreeToHtml.types';

export const italicRender: IRender = (text): string => {
  if (!text) {
    return '';
  }

  return `<i>${text}</i>`;
};
